import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getGroupOrAccountBillingUrl } from '../../../../navigation/billing';

interface StateProps {
    url: string;
}

interface OwnProps {
    groupId: string;
    accountId: string;
    onClose?: () => void;
}

export const connectUnassignedBillLink = connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        url: getGroupOrAccountBillingUrl,
    })
);
